import { type ReactNode } from 'react';

const TD = 'px-md py-sm';
const BAR = 'animate-pulse rounded-sm bg-white/[0.05]';

function SkeletonRow(): ReactNode {
  return (
    <tr className="border-b border-white/[0.03]">
      <td className={TD}>
        <div className={`h-3 w-6 ${BAR}`} />
      </td>
      <td className={TD}>
        <div className="flex items-center gap-sm">
          <div className={`h-6 w-6 shrink-0 rounded-full ${BAR}`} />
          <div className={`h-[13px] w-24 ${BAR}`} />
        </div>
      </td>
      <td className={`${TD} whitespace-nowrap`}>
        <div className={`h-3 w-32 ${BAR}`} />
      </td>
      <td className={TD}>
        <div className={`h-5 w-16 rounded-sm ${BAR}`} />
      </td>
      <td className={TD}>
        <div className={`h-5 w-20 rounded-md ${BAR}`} />
      </td>
    </tr>
  );
}

export function ApproacherTableSkeleton(): ReactNode {
  return (
    <tbody>
      {Array.from({ length: 6 }, (_, i) => (
        <SkeletonRow key={i} />
      ))}
    </tbody>
  );
}
